<template>
  <div
    v-if="modelValue"
    class="fixed inset-0 z-[1050] bg-black/40 flex items-end sm:items-center justify-center"
    @click.self="close"
  >
    <aside class="bg-white w-full sm:max-w-lg max-h-[92vh] rounded-t-lg sm:rounded-lg overflow-hidden flex flex-col text-left">
      <div class="p-4 border-b border-gray-100 flex items-center justify-between gap-3">
        <div class="text-left">
          <h2 class="text-lg font-semibold text-gray-900 text-left">Filter Users</h2>
        </div>
        <button
          type="button"
          class="h-9 w-9 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-200 flex items-center justify-center"
          @click="close"
          aria-label="Close filters"
        >
          <span class="material-symbols-outlined text-xl">close</span>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto p-4 space-y-4">
        <label class="block text-left">
          <span class="text-sm font-medium text-gray-700 text-left block">Role</span>
          <select
            v-model="localFilters.role"
            class="mt-1 w-full border border-gray-200 rounded-lg px-3 py-3 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-left"
          >
            <option value="">Any role</option>
            <option value="admin">Admin</option>
            <option value="user">Student</option>
          </select>
        </label>

        <label class="block text-left">
          <span class="text-sm font-medium text-gray-700 text-left block">Faculty</span>
          <select
            v-model="localFilters.faculty"
            class="mt-1 w-full border border-gray-200 rounded-lg px-3 py-3 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-left"
          >
            <option value="">Any faculty</option>
            <option v-for="faculty in faculties" :key="faculty" :value="faculty">{{ faculty }}</option>
          </select>
        </label>

        <div class="grid grid-cols-2 gap-3">
          <label class="block text-left">
            <span class="text-sm font-medium text-gray-700 text-left block">Study Year</span>
            <select
              v-model="localFilters.studyYear"
              class="mt-1 w-full border border-gray-200 rounded-lg px-3 py-3 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-left"
            >
              <option value="">Any</option>
              <option v-for="year in studyYears" :key="year" :value="year">Year {{ year }}</option>
            </select>
          </label>

          <label class="block text-left">
            <span class="text-sm font-medium text-gray-700 text-left block">Campus</span>
            <select
              v-model="localFilters.campus"
              class="mt-1 w-full border border-gray-200 rounded-lg px-3 py-3 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-left"
            >
              <option value="">Any</option>
              <option v-for="campus in campuses" :key="campus" :value="campus">{{ campus }}</option>
            </select>
          </label>
        </div>
      </div>

      <div class="p-4 border-t border-gray-100 grid grid-cols-2 gap-3">
        <button
          type="button"
          class="px-4 py-2.5 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 font-semibold transition-colors"
          @click="reset"
        >
          Reset
        </button>
        <button
          type="button"
          class="px-4 py-2.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 font-semibold transition-colors"
          @click="apply"
        >
          Apply
        </button>
      </div>
    </aside>
  </div>
</template>

<script>
export default {
  name: 'AdminUserFilterSheet',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      default: () => ({})
    },
    faculties: {
      type: Array,
      default: () => []
    },
    campuses: {
      type: Array,
      default: () => []
    },
    studyYears: {
      type: Array,
      default: () => [1, 2, 3, 4, 5, 6, 7]
    }
  },
  emits: ['update:modelValue', 'apply'],
  data() {
    return {
      localFilters: this.emptyFilters()
    };
  },
  watch: {
    modelValue(open) {
      if (open) {
        this.localFilters = { ...this.emptyFilters(), ...this.filters };
      }
    }
  },
  methods: {
    emptyFilters() {
      return {
        role: '',
        faculty: '',
        studyYear: '',
        campus: ''
      };
    },
    close() {
      this.$emit('update:modelValue', false);
    },
    apply() {
      this.$emit('apply', { ...this.localFilters });
      this.close();
    },
    reset() {
      this.localFilters = this.emptyFilters();
      this.$emit('apply', this.emptyFilters());
      this.close();
    }
  }
};
</script>
